export const spin = {
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh'
};
